import "./index.scss";
import { EXTERNAL_LINKS } from "routes/paths";
import { Button, InputLabel } from "components/UI/atoms";

export const PartnershipsForm = () => {
  return (
    <form
      className="partnerships-form"
      method="post"
      action={EXTERNAL_LINKS.SALESFORCE_HELP}
    >
      <fieldset>
        <InputLabel
          name="first_name"
          type="text"
          label="First Name"
          id="first_name"
          required
        />
        <InputLabel
          name="last_name"
          type="text"
          label="Last Name"
          id="last_name"
          required
        />
        <InputLabel
          name="email"
          type="email"
          label="Email"
          id="email"
          required
        />
        <InputLabel name="phone" type="tel" label="Phone" id="phone" required />
        <InputLabel
          name="company"
          type="text"
          label="Company"
          id="company"
          required
        />
        <InputLabel
          name="00N60000002pgWD"
          type="text"
          label="How can we help you?"
          id="00N60000002pgWD"
          required
        />
      </fieldset>
      <InputLabel
        name="00N60000002pgW8"
        type="checkbox"
        label="Subscribe to our Monthly Newsletter"
        id="00N60000002pgW8"
        customClassname="subscribe-checkbox"
      />
      <Button type="submit" customClassName="subscribe-button">
        Submit
      </Button>
    </form>
  );
};
